import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, RadialLinearScale, Title, Tooltip, BarController, LineController, LineElement, PointElement, } from 'chart.js';
import { Component } from 'react';
import { Card, Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import { Bar, Doughnut } from 'react-chartjs-2';
import DataTable from 'react-data-table-component';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { GET } from '../../api';
import { t } from '../../helpers/translation_helper';
import Header from '../_partials/Header/_Header';
import NavBar from '../_partials/NavBar/_NavBar';
import './analysis.css';
import moment from 'moment/moment';
import Paginate from '../_partials/Paginate/_Paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { Chart, Radar } from 'react-chartjs-2';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LineController,
  BarController,
  PointElement,
  LineElement,
);

// API URL
const apiURL = process.env.REACT_APP_API_URL;

/**
 * Analysis Component
 */
class Analysis extends Component {
  // State
  state = {
    achievement: null,
    charts: null,
    backgroundColor: [
      '#0CBBE7',
      '#00D045',
      '#EE3A81',
      '#FCEC6B',
      '#C75FC9',
      '#3C63AE',
      '#FC876B',
      '#6A9C06',
      '#E33030',
    ],
    points__data: [],
    points__loading: false,
    points__totalRows: 0,
    points__perPage: 10,
    examResults__data: [],
    examResults__loading: false,
    examResults__totalRows: 0,
    examResults__perPage: 10,
    subjectsAnalytics: null,
    gradeBookData: [],
    limit: 10,
    total_records: 0,
    reportData: {
      processing: false,
      data: {},
      finished: false
    },
  };

  componentDidMount() {
    this.getAchievement();
    this.getCharts();
    this.getPoints(1);
    this.getExamResults(1);
    this.getSubjectsAnalytics();
    this.getGradeBookData();
    this.getGeneralPerformanceData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedChild } = this.props;
    if (prevProps.selectedChild.child_id !== selectedChild.child_id || prevProps.selectedChild.class_id !== selectedChild.class_id) {
      this.getAchievement();
      this.getCharts();
      this.getPoints(1);
      this.getExamResults(1);
      this.getSubjectsAnalytics();
      this.getGradeBookData();
      this.getGeneralPerformanceData();
    }
  }

  /**
   * Get Achievement Data
   */
  getAchievement = async () => {
    const { child_id, class_id } = this.props.selectedChild;

    let request_params = {
      class_id,
      child_id,
    };

    try {
      const req = await GET(
        'dashboard/get-student-points',
        {
          params: request_params,
        }
      );
      this.setState({
        achievement: req.data.data,
      });
    } catch (err) {
      toast.error('Something went wrong while fetching achievement!');
      // console.log(err);
    }
  };

  /**
   * Get Charts Data
   */
  getCharts = async () => {
    const { backgroundColor } = this.state;
    const { auth_key, center_id } = this.props.authData.loginData;
    const { child_id, class_id, agegroup_id } = this.props.selectedChild;

    let request_params = {
      center_id,
      class_id,
      child_id,
      auth_key,
      agegroup_id,
    };

    try {
      const req = await GET(
        'dashboard/chart-class-average',
        {
          params: request_params,
        }
      );

      const chart_data = req.data.data;

      this.setState({
        charts: {
          yourAverage: {
            labels: chart_data.all_acs_name,
            datasets: [
              {
                data: chart_data.yourAverage,
                backgroundColor,
              },
            ],
          },
          classAverage: {
            labels: chart_data.all_acs_name,
            datasets: [
              {
                data: chart_data.classAverage,
                backgroundColor,
              },
            ],
          },
          maxAverage: {
            labels: chart_data.all_acs_name,
            datasets: [
              {
                data: chart_data.maxAverage,
                backgroundColor,
              },
            ],
          },
          minAverage: {
            labels: chart_data.all_acs_name,
            datasets: [
              {
                data: chart_data.minAverage,
                backgroundColor,
              },
            ],
          },
        },
      });
    } catch (err) {
      toast.error('Something went wrong while fetching achievement!');
      // console.log(err);
    }
  };

  /**
   * Get Points Data
   */
  getPoints = async (page) => {
    this.setState({
      points__loading: true,
    });

    const { perPage__total } = this.state;
    const { auth_key, center_id } = this.props.authData.loginData;
    const { child_id } = this.props.selectedChild;

    let request_params = {
      center_id,
      child_id,
      page,
      offset: (page - 1) * 10,
      per_page: perPage__total,
      order: 'std_behaviour_id',
      auth_key,
    };

    try {
      const req = await GET('dashboard/table-points', {
        params: request_params,
      });

      this.setState({
        points__data: req.data.data,
        points__totalRows: req.data.total,
        points__loading: false,
      });
    } catch (err) {
      toast.error('Something went wrong while fetching points!');
      // console.log(err);
    }
  };

  handlePointsPageChange = (page) => {
    this.getPoints(page);
  };

  /**
   * Get Exam Results Data
   */
  getExamResults = async (page) => {
    this.setState({
      points__loading: true,
    });

    const { perPage__total } = this.state;
    const { auth_key, center_id } = this.props.authData.loginData;
    const { child_id, class_id } = this.props.selectedChild;

    let request_params = {
      center_id,
      child_id,
      class_id,
      page,
      offset: (page - 1) * 10,
      per_page: perPage__total,
      order: 'std_behaviour_id',
      auth_key,
    };

    try {
      const res = await GET('dashboard/table-exam-results',
        {
          params: request_params,
        }
      );

      this.setState({
        examResults__data: res.data.data,
        examResults__totalRows: res.data.total,
        examResults__loading: false,
      });
    } catch (err) {
      toast.error('Something went wrong while fetching points!');
    }
  };

  /**
   * Handle Exam Results Page Change Event
   * @param {number} page
   */
  handleExamResultsPageChange = (page) => {
    this.getExamResults(page);
  };

  /**
   * Get Subjects Analytics
   */
  getSubjectsAnalytics = async () => {
    this.setState({ subjectsAnalytics: null });
    const { authData, selectedChild } = this.props;
    const { class_id, agegroup_id, child_id } = selectedChild;
    const { center_id } = authData.centerData;
    const { auth_key } = authData.loginData;
    const { backgroundColor } = this.state;

    const params = {
      class_id,
      child_id,
      center_id,
      agegroup_id,
      auth_key: auth_key,
    };

    try {
      const res = await GET('dashboard/chart-class-subject-average',
        {
          params,
        }
      );

      const barChartData = [];

      res.data.data.map((item) => {
        const bar_data = {
          labels: [
            t('Your Average'),
            t('Class Average'),
            t('Max Average'),
            t('Min Average'),
          ],
          datasets: [
            {
              label: item.acs_name,
              data: [
                item.yourAverage,
                item.classAverage,
                item.maxAverage,
                item.minAverage,
              ],
              backgroundColor,
              borderRadius: 20,
              barThickness: 40,
              borderSkipped: false,
            },
          ],
        };

        barChartData.push({
          acs_name: item.acs_name,
          bar_data,
        });
      });

      this.setState({
        subjectsAnalytics: barChartData,
      });
    } catch (err) {
      this.setState({
        subjectsAnalytics: [],
      });
      toast.error(
        'Something went wrong while fetching subjects analytics!'
      );
      // console.log(err);
    }
  };

  getGradeBookData = async (limit = this.state.limit, offset = 0) => {

    const { selectedChild } = this.props;
    const { child_id } = selectedChild;

    if (this.getDataReq) {
      this.getDataReq.abort();
    }
    this.getDataReq = new AbortController();
    try {
      const res = await GET('dashboard/fetch-exams-homework-table', {
        params: {
          search: '',
          order: 'exams.exams_id',
          dir: 'DESC',
          limit,
          offset,
          child_id
        },
        signal: this.getDataReq.signal,
      });
      this.setState({
        gradeBookData: res.data.data
      });
    } catch (err) {
      console.log(err);
    }
  }

  getGeneralPerformanceData = () => {
    let reportData = this.state.reportData

    this.setState({ reportData: { ...reportData, processing: true, data: {} } })

    try {
      if (this.fetchReportReq) {
        this.fetchReportReq.abort();
      }
      this.fetchReportReq = new AbortController();
      GET('dashboard/get-report-student-integrity', {
        params: {
          class_id: this.props.selectedChild.class_id,
          child_id: this.props.selectedChild.child_id
        },
        signal: this.fetchReportReq.signal,
      }).then((res) => {

        if (res) {
          this.setState({ reportData: { ...reportData, processing: false, data: res.data, finished: true }, reRenderTime: moment() })
        } else {
          toast.error(t('Something went wrong while deleting!'));
          this.setState({ reportData: { ...reportData, processing: false, data: {} } })
        }
      })
    } catch (err) {
      // console.log('err', err)
      toast.error(t('Something went wrong while deleting!'));

      this.setState({ reportData: { ...reportData, processing: false, data: {} } })
    }
  }


  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    // State
    const {
      achievement,
      charts,
      points__data,
      points_loading,
      points__totalRows,
      examResults__loading,
      examResults__data,
      examResults__totalRows,
      subjectsAnalytics,
      reportData
    } = this.state;

    // Achievement style 💅 class
    let achievement_class = 'border-0 achievement';
    if (achievement !== null && achievement.lastAward) {
      achievement_class = 'border-0 achievement trophy';
    }
    if (achievement !== null && !achievement.lastAward) {
      achievement_class = 'border-0 achievement thumbs-up';
    }

    // Chart options
    const options = {
      plugins: {
        legend: {
          display: false,
        },
      },
    };
    const bar_options = {
      // responsive: true,
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        }
      },
    };

    // Points DT columns
    const points__columns = [
      {
        name: 'Date',
        selector: (row) => row.date,
      },
      {
        name: 'Award',
        selector: (row) => row.award_name,
      },
      {
        name: 'Points',
        selector: (row) => row.points,
      },
      {
        name: 'Comments',
        selector: (row) => row.behaviour,
      },
      {
        name: 'From',
        selector: (row) => row.employee_name,
      },
    ];

    // Exam Results DT columns
    const examResults__columns = [
      {
        name: 'Exam',
        selector: (row) => row.exams_name,
      },
      {
        name: 'Subject',
        selector: (row) => row.acs_name,
      },
      {
        name: 'Date',
        selector: (row) => row.exams_date,
      },
      {
        name: 'Total Marks',
        selector: (row) => row.examsgrade_totalgrade,
      },
      {
        name: 'Highest',
        selector: (row) => row.qmax,
      },
      {
        name: 'Lowest',
        selector: (row) => row.qmin,
      },
    ];

    return (
      <Container fluid id='analysis-page'>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={t('Analysis')} showChildSelector={true} />
            <div className='grey-section'>
              <Row>
                <Col>
                  <Card className={achievement_class}>
                    <Card.Body>
                      {achievement == null ? (
                        <div
                          style={{
                            height: '200px',
                            flexDirection: 'column',
                          }}
                          className='d-flex justify-content-center align-items-center'>
                          <span className='mb-1'>
                            <Spinner
                              animation='grow'
                              variant='dark'
                            />
                          </span>
                          {t(
                            'Fetching achievement...'
                          )}
                        </div>
                      ) : (
                        <>
                          {achievement.lastAward ? (
                            <>
                              {' '}
                              <h3>
                                {t(
                                  'Congratulations!'
                                )}
                              </h3>
                              <p>
                                {t(
                                  'You got a Award'
                                )}
                              </p>
                              <p>
                                <strong>
                                  {t(
                                    'Encouragement'
                                  )}
                                </strong>
                                <br />
                                <span
                                  className='badge'
                                  style={{
                                    backgroundColor:
                                      '#00D045',
                                  }}>
                                  15{' '}
                                  {t(
                                    'Points'
                                  )}
                                </span>
                              </p>
                            </>
                          ) : (
                            <>
                              <h3>
                                {t(
                                  'Keep it up!'
                                )}
                              </h3>
                              <p>
                                {t(
                                  'You are doing good.'
                                )}
                              </p>
                              <p>
                                <strong>
                                  {t(
                                    'Study hard to get'
                                  )}
                                  <br />
                                  {t(
                                    'more points.'
                                  )}
                                </strong>
                              </p>
                            </>
                          )}
                          <p>
                            {t('Total Points')}
                            <br />
                            <strong
                              style={{
                                fontSize:
                                  '25px',
                              }}>
                              {
                                achievement.totalPoints
                              }
                            </strong>
                          </p>
                        </>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={2}>
                  <Card className='border-0 graph-card'>
                    <Card.Body>
                      <Card.Subtitle className='mb-4'>
                        {t('Your Average')}
                      </Card.Subtitle>
                      {charts !== null ? (
                        <Doughnut
                          data={charts.yourAverage}
                          options={options}
                        />
                      ) : (
                        <div
                          style={{
                            height: '175px',
                            flexDirection: 'column',
                          }}
                          className='d-flex justify-content-center align-items-center'>
                          <span className='mb-1'>
                            <Spinner
                              animation='grow'
                              variant='dark'
                            />
                          </span>
                          {t('Fetching average...')}
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={2}>
                  <Card className='border-0 graph-card'>
                    <Card.Body>
                      <Card.Subtitle className='mb-4'>
                        {t('Class Average')}
                      </Card.Subtitle>
                      {charts !== null ? (
                        <Doughnut
                          data={charts.classAverage}
                          options={options}
                        />
                      ) : (
                        <div
                          style={{
                            height: '175px',
                            flexDirection: 'column',
                          }}
                          className='d-flex justify-content-center align-items-center'>
                          <span className='mb-1'>
                            <Spinner
                              animation='grow'
                              variant='dark'
                            />
                          </span>
                          {t('Fetching average...')}
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={2}>
                  <Card className='border-0 graph-card'>
                    <Card.Body>
                      <Card.Subtitle className='mb-4'>
                        {t('Highest Average')}
                      </Card.Subtitle>
                      {charts !== null ? (
                        <Doughnut
                          data={charts.maxAverage}
                          options={options}
                        />
                      ) : (
                        <div
                          style={{
                            height: '175px',
                            flexDirection: 'column',
                          }}
                          className='d-flex justify-content-center align-items-center'>
                          <span className='mb-1'>
                            <Spinner
                              animation='grow'
                              variant='dark'
                            />
                          </span>
                          {t('Fetching average...')}
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={2}>
                  <Card className='border-0 graph-card last-graph-card'>
                    <Card.Body>
                      <Card.Subtitle className='mb-4'>
                        {t('Lowest Average')}
                      </Card.Subtitle>
                      {charts !== null ? (
                        <Doughnut
                          data={charts.minAverage}
                          options={options}
                          width={40}
                          height={40}
                        />
                      ) : (
                        <div
                          style={{
                            height: '175px',
                            flexDirection: 'column',
                          }}
                          className='d-flex justify-content-center align-items-center'>
                          <span className='mb-1'>
                            <Spinner
                              animation='grow'
                              variant='dark'
                            />
                          </span>
                          {t('Fetching average...')}
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row style={{ paddingTop: 20 }}>
                <Col>
                  <Card
                    className='border-0'
                    style={{
                      borderRadius: 10,
                    }}>
                    <Card.Body>
                      <Card.Title>
                        {t('Gradebook')}
                      </Card.Title>
                      <Table style={{ fontSize: 12, marginTop: 10 }}>
                        <tbody>
                          {this.state.gradeBookData.map((item, index) => (
                            <tr key={index}>
                              <td style={{ color: '#B8B8B8', padding: '15px 0' }}>{item.acs_name} | {item.class_theme}</td>
                              <td style={{ padding: '15px 0' }}><strong>{item.exams_name}</strong></td>
                              <td style={{ padding: '15px 0' }}>{moment(item.exams_date).format('DD-MM-YYYY')}</td>
                              <td style={{ textAlign: 'center', padding: '15px 0' }}><span style={{
                                background: '#62CCF4',
                                fontWeight: 'bold',
                                borderRadius: 5,
                                color: '#fff',
                                padding: '5px 10px'
                              }}>{item.examstype_name}</span></td>
                              <td style={{ textAlign: 'center', padding: '15px 0' }}><span style={{
                                background: item.examstypegrp_type === 'Exam' ? '#DD4488' : '#F3BF00',
                                fontWeight: 'bold',
                                borderRadius: 5,
                                color: item.examstypegrp_type === 'Exam' ? '#fff' : '#000',
                                padding: '5px 10px'
                              }}>{item.examstypegrp_type}</span></td>
                              <td style={{ padding: '15px 0', textAlign: 'right' }}>
                                <span style={{
                                  background: '#F3BF00',
                                  borderRadius: 5,
                                  color: '#000',
                                  padding: '5px 10px 5px 5px'
                                }}>
                                  <span style={{ background: '#fff', borderRadius: 3, padding: '0 5px', fontWeight: 'bold' }}>{item.examsgrade_grade}</span> / {item.examsgrade_totalgrade}
                                </span>
                              </td>
                              <td style={{ padding: '15px 0', textAlign: 'right' }}>
                                <span
                                  title={t('Highest Grades')}
                                  style={{
                                    background: '#b7e543',
                                    borderRadius: 5,
                                    color: '#fff',
                                    padding: '3px 5px',
                                    fontWeight: 'bold',
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                    display: 'inline-block'
                                  }}><FontAwesomeIcon icon={faArrowUp} />
                                  <span style={{
                                    background: '#fff',
                                    borderRadius: 3,
                                    padding: '0 5px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    display: 'inline-block',
                                    width: 30,
                                    textAlign: 'center',
                                    marginLeft: 5
                                  }}>{item.qmax}</span></span>
                                <span
                                  title={t('Lowest Grades')}
                                  style={{
                                    background: '#ff8d97',
                                    borderRadius: 5,
                                    color: '#fff',
                                    padding: '3px 5px',
                                    fontWeight: 'bold',
                                    borderTopLeftRadius: 0,
                                    borderBottomLeftRadius: 0,
                                    display: 'inline-block'
                                  }}><span style={{
                                    background: '#fff',
                                    borderRadius: 3,
                                    padding: '0 5px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    display: 'inline-block',
                                    width: 30,
                                    textAlign: 'center',
                                    marginRight: 5
                                  }}>{item.qmin}</span>
                                  <FontAwesomeIcon icon={faArrowDown} /></span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <Paginate
                        limit={this.state.limit}
                        totalRecords={this.state.total_records}
                        pageChange={this.getGradeBookData}
                      />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row style={{ paddingTop: 20 }}>
                <Col>
                  <Card
                    className='border-0'
                    style={{
                      borderRadius: 10,
                    }}>
                    <Card.Body>
                      <div className='d-flex flex-row flex-wrap'>
                        {reportData.data.unique_centerlic_data && Object.values(reportData.data.unique_centerlic_data).map((v, i) => {
                          if (v.exams_data.length <= 0) {
                            return null
                          }
                          let uniqueAcademicSubjects = []
                          v.exams_data.map((v) => {
                            let find_uniqueAcademicSubjects = uniqueAcademicSubjects.find((vv, ii) => v.as_id == vv.as_id)
                            if (!find_uniqueAcademicSubjects) {
                              uniqueAcademicSubjects.push({ as_id: v.as_id, as_name: v.as_name })
                            }
                          })

                          const data = {
                            labels: uniqueAcademicSubjects.map((vv) => vv.as_name),
                            datasets: [
                              {
                                label: 'Year ' + v.reg_year,
                                data: uniqueAcademicSubjects.map((vv) => {
                                  let calculatedAverages = 0
                                  let count = 0
                                  v.exams_data.map((vvv) => {
                                    if (vvv.as_id == vv.as_id) {
                                      calculatedAverages += (parseFloat(vvv.examsgrade_grade) / parseFloat(vvv.exams_grade)) * 100
                                      count++
                                    }
                                  })
                                  return parseFloat(calculatedAverages / count).toFixed(2)
                                }),
                                backgroundColor: '#CCF6DA',
                                borderColor: '#00d045',
                                borderWidth: 1,
                              },
                            ],
                          };


                          return <div className='mb-2' style={{ width: '100%' }}>
                            <Card.Title>
                              {t('General Performance')} ({'Year ' + v.reg_year})
                            </Card.Title>
                            <Card.Body className='d-flex flex-row align-items-center'>
                              <div style={{ width: '30%' }}>
                                <Radar data={data} />
                              </div>
                              <div style={{ width: '70%' }}>
                                <Card>
                                  {uniqueAcademicSubjects.map((vv) => {
                                    let labels2 = []
                                    v.exams_data.map((vvv, iii) => {
                                      if (vvv.as_id == vv.as_id) {
                                        labels2.push(vvv)
                                      }
                                    })

                                    let data2 = {
                                      labels: labels2.map((vvv) => vvv.exams_name),
                                      datasets: [
                                        {
                                          type: 'line',
                                          label: 'Class Average',
                                          borderColor: '#F39400',
                                          borderWidth: 2,
                                          fill: false,
                                          data: labels2.map((vvv) => vvv.exam_average),
                                        },
                                        {
                                          type: 'bar',
                                          label: 'Student Grade',
                                          backgroundColor: '#CCF6DA',
                                          data: labels2.map((vvv) => vvv.examsgrade_grade),
                                          borderColor: '#00d045',
                                          borderWidth: 2,
                                        },
                                      ],
                                    }
                                    let options2 = {
                                      responsive: true,
                                      plugins: {
                                        legend: {
                                          position: 'top',
                                        },
                                        title: {
                                          display: true,
                                          text: vv.as_name,
                                        },
                                      },
                                    }


                                    return <Card.Body>
                                      <Chart height={60} type='bar' options={options2} data={data2} />
                                    </Card.Body>
                                  })}
                                </Card>

                              </div>
                            </Card.Body>
                          </div>
                        })
                        }
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              {subjectsAnalytics == null &&
                <Row
                  style={{
                    paddingTop: 20,
                    marginBottom: 20,
                  }}>
                  <Col>
                    <Card className='border-0'>
                      <Card.Body>
                        <div
                          style={{
                            height: '175px',
                            flexDirection: 'column',
                          }}
                          className='d-flex justify-content-center align-items-center'>
                          <span className='mb-1'>
                            <Spinner
                              animation='grow'
                              variant='dark'
                            />
                          </span>
                          {t(
                            'Fetching subjects analytics...'
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              }
              {subjectsAnalytics?.length == 0 && (
                <Row
                  style={{
                    paddingTop: 20,
                    marginBottom: 20,
                  }}>
                  <Col>
                    <Card className='border-0'>
                      <Card.Body>
                        <div
                          style={{
                            height: '175px',
                            flexDirection: 'column',
                          }}
                          className='d-flex justify-content-center align-items-center'>
                          {t(
                            'No subjects analytics found!'
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}
              {subjectsAnalytics?.length > 0 && (
                <Row style={{ paddingTop: 20 }}>
                  {subjectsAnalytics.map((item, index) => (
                    <Col
                      key={index}
                      md={4}
                      style={{ marginBottom: 20 }}>
                      <Card className='border-0'>
                        <Card.Body>
                          <Card.Title className='mb-2'>
                            {t(item.acs_name)}{' '}
                            {t('Analysis')}
                          </Card.Title>
                          <Bar
                            options={bar_options}
                            data={item.bar_data}
                          />
                          <div>
                            {item.bar_data.labels.map((v, i) => {
                              return <div className='d-flex flex-row align-items-center justify-content-between' style={{ fontSize: 13 }}>
                                <div>{v}</div>
                                <div>{item.bar_data.datasets[0].data[i]}</div>
                              </div>
                            })}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}
              <Row>
                <Col>
                  <Card
                    className='border-0'
                    style={{
                      borderRadius: 10,
                      borderBottomRightRadius: 20,
                      borderBottomLeftRadius: 20,
                    }}>
                    <Card.Body>
                      <Card.Title>
                        {t('Points')}
                      </Card.Title>
                      <DataTable
                        columns={points__columns}
                        progressPending={points_loading}
                        data={points__data}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          points__totalRows
                        }
                        onChangePage={
                          this.handlePointsPageChange
                        }
                      />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              {/* <Row style={{ paddingTop: 20 }}>
                <Col>
                  <Card
                    className='border-0'
                    style={{
                      borderRadius: 10,
                    }}>
                    <Card.Body>
                      <Card.Title>
                        {t('Exam Results')}
                      </Card.Title>
                      <DataTable
                        columns={examResults__columns}
                        progressPending={
                          examResults__loading
                        }
                        data={examResults__data}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          examResults__totalRows
                        }
                        onChangePage={
                          this
                            .handleExamResultsPageChange
                        }
                      />
                    </Card.Body>
                  </Card>
                </Col>
              </Row> */}
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedChild: state.selectedChild.data,
  languages: state.language.languages,
  defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(Analysis);
